import React, {useEffect, useState} from 'react';
import {Link, useOutletContext, useParams, useSearchParams} from 'react-router-dom';
import TitleMain from "../../../components/Title/TitleMain";
import {useModal} from "../../../contexts/ModalContext";
import {useUser} from "../../../contexts/UserContext";
import AxiosConfig from "../../../services/AxiosConfig";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";
import ActiviteCreation from "../../../components/Admin/Activtes/ActiviteCreation";
import ActivitesVue from "../../../components/Admin/Activtes/ActivitesVue";
import JustificatifTypeCreation from "../../../components/Admin/JustificatifTypes/JustificatifTypeCreation";
import JustificatifTypeTable from "../../../components/Admin/JustificatifTypes/JustificatifTypeTable";
import styles from "../../../pages/Admin/Admin.module.css";
import { ReactComponent as AjouterIcone } from "../../../icons/ajouter.svg";
import Routing from "../../../services/routing";

function AdminJustificatifTypesPage() {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [myApiData, setMyApiData] = useState([]);
    const { updateDynamicBreadcrumb } = useBreadcrumb();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'consultation';

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    const getJustificatifTypes = async () => {
        try {
            const response = await AxiosConfig.get(`/admin/justificatifs/types`);
            setMyApiData(response.data.myJustificatifTypes);
        } catch (error) {
            console.error('error', error);
        }
    }

    const putActifOpenModal = (row) => {
        const text = row.justActif ? "supprimer ce type de justificatif" : "activer ce type de justificatif";
        showModal('confirm', {
            children: `Voulez-vous vraiment ${text} ?`,
            onConfirm: async () => {
                try {
                    const response = await AxiosConfig.post(`/admin/justificatifs/types/${row.justId}/actif`, {actif: !row.justActif});
                    if (response.data.success) {
                        setTimeout(async () => {
                            const response = await getJustificatifTypes();
                        }, 500);
                    }
                    handleSuccess("Statut modifié avec succès");
                } catch (error) {
                    console.error('error', error);
                    handleError();
                }
            }
        });
    }

    const putObligatoireOpenModal = (row) => {
        showModal('confirm', {
            children: "Voulez-vous vraiment faire ceci ?",
            onConfirm: async () => {
                try {
                    const response = await AxiosConfig.post(`/admin/justificatifs/types/${row.justId}/obligatoire`, {obligatoire: !row.justObligatoire});
                    if (response.data.success) {
                        setTimeout(async () => {
                            const response = await getJustificatifTypes();
                        }, 500);
                    }
                    handleSuccess("Statut modifié avec succès");
                } catch (error) {
                    console.error('error', error);
                    handleError();
                }
            }
        });
    }

    useEffect(() => {
        getJustificatifTypes();
    }, [mode]);

    useEffect(() => {
        updateDynamicBreadcrumb(generateBreadcrumbSegmentsAdmin({ }));
    }, []);

    return (
        <div className="content_tab">
            <TitleMain text="Types de justificatif"/>

            {mode === 'creation' ?
                <JustificatifTypeCreation /> :

                <>
                    <div className={styles.navLink}>
                        <Link to={Routing.routes.adminCreation}>
                            <AjouterIcone/>
                            Ajouter un type de justificatif
                        </Link>
                    </div>

                    <JustificatifTypeTable justificatifType={myApiData} putActifOpenModal={putActifOpenModal} putObligatoireOpenModal={putObligatoireOpenModal}/>
                </>
            }

        </div>
    )
}

export default AdminJustificatifTypesPage;
